const URL = '  https://food-mafia-server.herokuapp.com/api/';

export const getAllProfiles = () => 
    fetch(URL+"getProfiles").
        then(response => 
            response.json());


//Delete the profile and reload the page 
export const deleteProfile = (user) => {
    //console.lo
    fetch(URL + "deleteProfile/" + user._id, {
        method: 'DELETE'
    }).then(status => window.location.reload())
}